import { useEffect, useRef } from "react";
import { trackEvent } from "~/utils/monitoring";

// Emits a single Mixpanel/RUM event the first time the Pins page settles after
// loading, capturing how many entities the user currently has pinned. The count
// is only meaningful once loading completes, so the event is deferred until then
// and guarded to fire once per page visit — pinning or unpinning afterwards must
// not re-emit the view.
const useTrackPinnedEntitiesViewed = (count: number, loading: boolean) => {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (loading || hasTracked.current) {
      return;
    }
    hasTracked.current = true;
    trackEvent("pinned_entities_viewed", { count });
  }, [loading, count]);
};

export default useTrackPinnedEntitiesViewed;
